<template>
    <div class="body">
      <div class="header">
        <el-form :model="SelectOrderManagementDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产品大类">
                    <el-input

                        v-model="SelectOrderManagementDTO.category"
                        placeholder=""
                    ></el-input>
                </el-form-item>
   
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button class="btn-style btn-buy"  type="warning" @click="downLoad">
              导出
            </el-button>


        </el-form>
      
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑特殊工艺设置" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
         
     
    <el-form-item  label="名称" prop="name">
          <el-input
            class="input-remark"
            
            v-model="accountForm.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button  type="primary" @click="editAccount()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>

      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          show-summary
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
  
        <el-table-column
            prop="category"
            align="center"
            label="产品种类"
          ></el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="产品规格"
          ></el-table-column>
          <el-table-column
            prop="orderAmounts"
            align="center"
            label="订单金额"
          ></el-table-column>
  
        </el-table>
      </div>
  

    </div>
  </template>
  
  <script>
  import { selectAmountByCategory,downLoadAmountByCategory} from '@/api/order/trade.js'
  import { exportExcel } from '../../utils/index'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        SelectOrderManagementDTO:{
            category:'',
          access:'',
            startTime: '',
            endTime: '',
            category: '',
            productionProcesses:''
        },
        category:[],
        drawer: false,
        dialogVisible:false,
        accountForm:{
          id:'',
          access:'',
          name:'',
          price:'',
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
          name:[
                    { required: true, message: '请输入名称', trigger: 'blur' }]
           
            }

      }
    },
    
  
    mounted() {
      this.SelectOrderManagementDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
        this.defaultDate()
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        selectAmountByCategory(this.SelectOrderManagementDTO).then((res) => {
            console.log(res.data.data)
          this.conTract = res.data.data
        })
      },
    

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      downLoad() {
        downLoadAmountByCategory(this.SelectOrderManagementDTO)
          .then((res) => {
            if (res.status === 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.SelectOrderManagementDTO.startTime = e[0]
          this.SelectOrderManagementDTO.endTime = e[1]
        } else if (!e) {
          this.SelectOrderManagementDTO.startTime = ''
          this.SelectOrderManagementDTO.endTime = ''
        }
      },
      defaultDate() {
      var date = new Date()
      var year = date.getFullYear().toString()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()
      // var da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
      var da = new Date(date.getFullYear(), month, 0).getDate()
      da < 10 ? '0' + da.toString() : da.toString()
      var start = year + '-' + month + '-01'
   
      this.SelectOrderManagementDTO.startTime= new Date(start)
      const end = new Date()
     
      this.SelectOrderManagementDTO.endTime= end
      this.date=[this.SelectOrderManagementDTO.startTime,this.SelectOrderManagementDTO.endTime]
     //将值设置给插件绑定的数据
     
    
    },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .btn-style{
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-buy{
    background: #FF8429;
}
  </style>
  